import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  signal,
  WritableSignal
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { slideInOut } from '../../../transitions/slide-in-out.transition';
import { AmountSelectorType } from '../../../interfaces/amount-selector.interface';

@Component({
  selector: 'app-amount-selector',
  templateUrl: './amount-selector.component.html',
  styleUrl: './amount-selector.component.scss',
  animations: [slideInOut],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: AmountSelectorComponent,
      multi: true
    }
  ],
  imports: [FormsModule, CurrencyPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AmountSelectorComponent implements ControlValueAccessor {
  protected readonly AmountSelectorType = AmountSelectorType;

  options: InputSignal<number[]> = input<number[]>([]);
  type: InputSignal<AmountSelectorType> = input<AmountSelectorType>(
    AmountSelectorType.Fixed
  );
  isCustomAmountVisible: InputSignal<boolean> = input<boolean>(true);

  // State
  value: WritableSignal<number | null> = signal<number | null>(null);
  isDisabled: WritableSignal<boolean> = signal<boolean>(false);
  isCustomAmountActive: WritableSignal<boolean> = signal<boolean>(false);

  onSelectAmount(amount: number): void {
    this.isCustomAmountActive.set(false);

    this.value.set(amount);
    this.onChange(amount);
    this.onTouch();
  }

  onSelectCustomAmount(): void {
    this.isCustomAmountActive.set(true);

    this.value.set(null);
    this.onChange(null);
    this.onTouch();
  }

  onCustomAmountChange(amount: number): void {
    this.value.set(amount);
    this.onChange(amount);
    this.onTouch();
  }

  // ControlValueAccessor
  private onChange = (value: number | null) => {};
  onTouch = () => {};

  registerOnChange(fn: (value: number | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }

  writeValue(outsideValue: number | null): void {
    this.value.set(outsideValue);
  }
}
